export const CategoryType = {
  PRIMARY: "primary",
  ADDITIONAL: "additional"
};
